<section class="pt-16 pb-8 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'Spettacoli', route: '/backoffice/spettacoli/' }, { label: 'Personale area compagnia', active: true }]"></app-breadcrumb-backoffice>
    <h1 class="lg:text-4xl text-2xl font-mono text-center uppercase">Personale area compagnia</h1>
</section>

<section class="px-container pb-16">
    <div class="ac-section-head">
        <div>
            <h2>Personale</h2>
            <span class="ac-meta">{{ spettacolo?.spettacolo || 'personale autorizzato' }}</span>
        </div>
    </div>

    @if (!loading) {
        <app-personale-accrediti-backoffice [visione]="true" [personale]="personale || []" [evento]="evento" />
    }
</section>

<app-loading-backoffice [visible]="loading"></app-loading-backoffice>
